import { usePage } from '@inertiajs/react';
import { useCallback, useMemo } from 'react';

/**
 * Read the current user's permission abilities (and roles) from the shared
 * Inertia props. Use `can(permission)` to gate UI and side effects such as
 * background fetches that would otherwise 403 for users lacking the permission.
 */
export function useAbilities() {
    const page = usePage();
    const auth = (page.props as { auth?: { abilities?: string[]; roles?: string[] } }).auth;

    const abilities = useMemo(() => auth?.abilities ?? [], [auth?.abilities]);
    const roles = useMemo(() => auth?.roles ?? [], [auth?.roles]);

    const can = useCallback((permission: string) => abilities.includes(permission), [abilities]);
    const isAdministrator = useMemo(() => roles.includes('Administrator'), [roles]);

    return { abilities, roles, can, isAdministrator };
}
